import React from "react";
import SlidingIconButton from "./SlidingIconButton";

interface ConnectionButtonProps {
  uuid: string;
}

const ConnectionButton: React.FC<ConnectionButtonProps> = ({ uuid }) => {
  return (
    <SlidingIconButton
      to={`${uuid}/connections`}
      color="text-white"
      text="Connecties bekijken"
      iconClass="d-network-policy"
      className="hover:w-[11.2rem] hover:border-sunshineYellow"
    />
  );
};

export default ConnectionButton;
